import style from "./Shortcut.module.css";
import { IShortcut, IShortcutLink } from "../../Home";

function ShortCutItem(props: IShortcutLink) {
    return (
        <li
            className={style.itemWrapper}
            onClick={() => window.open(props.url, '_blank')}
            role="link"
            tabIndex={0}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') window.open(props.url, '_blank');
            }}
        >
            {props.image && <img src={props.image} alt="" className={style.shortcutImg} />}
            <span className={style.itemTitle}>{props.title}</span>
            <span className={style.itemArrow} aria-hidden="true">→</span>
        </li>
    );
}

export default function ShortCut(props) {
    const shortcut: IShortcut = props as IShortcut;
    return (
        <div className={style.shortcutBlock}>
            <div className="intranet_tile_header">{shortcut.name}</div>
            <ul className={style.list}>
                {shortcut?.link.map((s, index) => <ShortCutItem key={index} {...s} />)}
            </ul>
        </div>
    );
}
